import React from 'react';
import PropTypes from 'prop-types';
import NarrowEndUserMealCard from '../meal/narrow_end_user_meal_card';

const RecipesSearchMealResultCard = ({
  mealID,
  parentID,
  title,
  imageUrl,
  onClick,
  favouriteEnabled,
  afterAddingToFavourites,
  onAddToPlanner,
}) => {
  return (
    <NarrowEndUserMealCard
      mealID={mealID}
      parentID={parentID}
      title={title}
      imageUrl={imageUrl}
      onClick={onClick}
      favouriteEnabled={favouriteEnabled}
      addToPlannerEnabled
      onAddToPlanner={onAddToPlanner}
      afterAddingToFavourites={afterAddingToFavourites}
    />
  );
};

RecipesSearchMealResultCard.propTypes = {
  mealID: PropTypes.string.isRequired,
  parentID: PropTypes.string,
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  favouriteEnabled: PropTypes.bool,
  onAddToPlanner: PropTypes.func.isRequired,
  afterAddingToFavourites: PropTypes.func,
};

RecipesSearchMealResultCard.defaultProps = {
  imageUrl: null,
  favouriteEnabled: false,
  parentID: null,
  afterAddingToFavourites: () => {},
};

export default RecipesSearchMealResultCard;
